import posthog from "posthog-js";
import { runtimeConfig } from "@/shared/config/runtimeConfig";

/**
 * Starts PostHog before React renders, so errors from the first render (root providers included)
 * reach `reportReactError` with PostHog already listening. Does nothing when PostHog is not
 * configured; `PostHogRoot` reports missing configuration in development.
 */
export function initPostHog(): void {
  const apiKey = runtimeConfig.POSTHOG_PROJECT_TOKEN.trim();
  const apiHost = runtimeConfig.POSTHOG_HOST.trim();
  if (!apiKey || !apiHost) {
    return;
  }

  const environment = runtimeConfig.TOWER_ENVIRONMENT;
  posthog.init(apiKey, {
    api_host: apiHost,
    defaults: "2026-01-30",
    capture_exceptions: true,
    debug: import.meta.env.DEV,
    logs: {
      serviceName: "tower-web",
      environment,
    },
  });
  // Every event carries its deployment environment, so environments sharing a project stay separable.
  posthog.register({ environment });
}
